import { useEffect, useState } from "react";
import axios from "axios";

function Test() {
  const [vendor, setvendor] = useState([]);
  useEffect(() => {
    const fetchvendor = async () => {
      try {
        const res = await axios.get("https://api-ims.indevconsultancy.in/vendor.php");
        setvendor(res.data); 
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchvendor();
  }, []);

  console.log('vendor', vendor)

  return (
    <div className="text-center">
      <h3>vendor</h3>
      {vendor.map((item) => (
        <div key={item.vendor_id}>{item.vendor_name}</div>
      ))}
    </div>
  );
}

export default Test;
